<template>
    <div>
        <v-autocomplete
            label="Add team member"
            data-cy="team_member_add"
            class="mb-6"
            rounded
            filled
            hide-details
            :items="filteredUsers"
            :item-value="(item) => item.text"
            :item-text="(item) => `${item.firstName} ${item.lastName}`"
            @input="(item) => addUser(item.id)"
            return-object
            v-model="selectedUser"
            :disabled="disabled"
        ></v-autocomplete>
        <v-list v-if="members.length">
            <v-list-item v-for="user of members" :key="user.id">
                <v-list-item-avatar>
                    <v-avatar class="text-h4 white--text" color="primary lighten-2">
                        {{ user.firstName[0] }}{{ user.lastName[0] }}
                        <!--                        <v-img :src="`https://source.unsplash.com/100x100/?face,${user.id}`"></v-img>-->
                    </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>
                        <router-link :to="{ name: 'user', params: { userId: user.id } }">
                            {{ user.firstName }} {{ user.lastName }}
                        </router-link>
                    </v-list-item-title>
                    <!--                    <v-list-item-subtitle>Last seen: 2 days ago</v-list-item-subtitle>-->
                </v-list-item-content>
                <v-list-item-icon>
                    <v-btn
                        rounded
                        @click.stop="removeUser(user.id)"
                        data-cy="team_member_delete"
                        depressed
                        class="text-h4"
                        color="secondary"
                        :disabled="disabled"
                        :data-team-member-id="user.id"
                    >
                        <v-icon left>mdi mdi-delete</v-icon>
                        Remove from team
                    </v-btn>
                </v-list-item-icon>
            </v-list-item>
        </v-list>
        <div class="mt-12 text-center text--secondary" v-else>There are no members in this team.</div>
    </div>
</template>

<script>
import { teamService } from "@/services/team";
import { userService } from "@/services/user";

export default {
    name: "team-members",
    components: {},
    props: {
        customerId: {
            type: Number,
            required: true,
        },
        teamId: {
            type: Number,
            required: true,
        },
        disabled: {
            type: Boolean,
        },
    },
    data() {
        return {
            members: [],
            users: [],
            selectedUser: null,
        };
    },
    computed: {
        filteredUsers() {
            return this.users.filter((u) => !this.members.some((m) => m.id === u.id));
        },
    },
    created() {},
    async mounted() {
        await this.refreshMembers();
        await this.refreshUsers();
    },
    destroyed() {},
    methods: {
        async refreshUsers() {
            this.users = await userService.find({
                params: { customer: this.$props.customerId },
            });
        },
        async refreshMembers() {
            this.members = await teamService.getUsers(this.$props.teamId);
        },
        async removeUser(userId) {
            await teamService.removeUser(this.$props.teamId, userId);
            await this.refreshMembers();
        },
        async addUser(userId) {
            this.$nextTick(() => {
                // Clear the input
                this.selectedUser = null;
            });
            await teamService.addUser(this.$props.teamId, userId);
            await this.refreshMembers();
        },
    },
};
</script>
